<template>
  <div id="redEnvelopeRecord">
    <mt-header fixed :title="$t('红包详情')">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
      <!-- <mt-button slot="right" class="join" @click="doshare()"><img src="@/assets/img/coinDetail/ico_fenxiang_shoukuan.png" alt=""></mt-button> -->
    </mt-header>
    <div class="header_top">
      <div class="top">
        <img v-bind:src="img_url" alt="" />
        <p
          class="wx_fontSize3"
          style="color: #1296db; font-weight: bold; padding: 0"
        >
          {{ red_envelope_data.total_amount | numFilter
          }}{{ red_envelope_data.coin_symbol }}
        </p>
        <p class="wx_fontSize2" style="color: #8c92a8">
          {{ red_envelope_data.wish }}
        </p>
      </div>
      <div class="footer wx_fontSize3" @click="copy($event)">
        {{ $t("将配好的红包分享给好友") }}
      </div>
      <p class="counted wx_fontSize2">
        {{ $t("已领取") }}{{ red_envelope_data.open_num }}/{{
          red_envelope_data.total_num
        }}{{ $t("个") }}
      </p>
    </div>

    <div class="content">
      <div
        class="page-loadmore-wrapper"
        ref="wrapper"
        :style="{ height: wrapperHeight + 'px' }"
      >
        <mt-loadmore
          :top-method="loadTop"
          @top-status-change="handleTopChange"
          :bottom-method="loadBottom"
          @bottom-status-change="handleBottomChange"
          :bottom-all-loaded="allLoaded"
          ref="loadmore"
          :auto-fill="false"
        >
          <ul class="content_detail">
            <li v-for="(item, index) in child_red_envelope" :key="index">
              <img v-bind:src="img_url" alt class="oImg" />
              <span class="currency_name">{{ item.open_user }}</span>
              <div class="amount_of wx_rt">
                <p class="count wx_fontSize3">
                  {{ item.amount | numFilter(item.amount)
                  }}{{ item.coin_symbol }}≈￥0
                </p>
                <p class="money wx_fontSize2">
                  {{ item.open_time | parseTime }}
                </p>
              </div>
            </li>
          </ul>
          <div slot="top" class="mint-loadmore-top">
            <span
              v-show="topStatus !== 'loading'"
              :class="{ 'is-rotate': topStatus === 'drop' }"
              >↓</span
            >
            <span v-show="topStatus === 'loading'">
              <mt-spinner type="snake"></mt-spinner>{{ $t("正在刷新...") }}
            </span>
          </div>
          <div slot="bottom" class="mint-loadmore-bottom">
            <span
              v-show="bottomStatus !== 'loading'"
              :class="{ 'is-rotate': bottomStatus === 'drop' }"
            ></span>
            <span v-show="bottomStatus === 'loading'">
              <mt-spinner type="snake"></mt-spinner>{{ $t("正在加载...") }}
            </span>
          </div>
        </mt-loadmore>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { httpRedEnvelopeInfo } from "@/api/index";
import { numFilter } from "@/filters/index";
import { parseTime } from "@/utils/index";
import { share } from "@/utils/index";
import handleClipboard from "@/utils/clipboard";
export default {
  data: function () {
    return {
      pageNo: 1,
      array_pages: "",
      allLoaded: false,
      bottomStatus: "",
      wrapperHeight: 0,
      topStatus: "",
      translate: 0,
      moveTranslate: 0,
      id: "",
      img_url: "",
      red_envelope_data: {},
      child_red_envelope: [],
    };
  },
  mounted() {
    this.wrapperHeight =
      document.documentElement.clientHeight -
      this.$refs.wrapper.getBoundingClientRect().top;
    this.id = this.$route.query.id;
    this.img_url = this.$route.query.img_url;
  },
  activated() {
    this.transactions(1);
    this.id = this.$route.query.id;
    this.img_url = this.$route.query.img_url;
  },
  filters: {
    numFilter(val) {
      if (val == undefined) {
        return "";
      }
      return numFilter(val);
    },
  },
  deactivated() {
    this.$destroy(true);
  },
  methods: {
    handleBottomChange(status) {
      this.bottomStatus = status;
    },
    loadBottom() {
      var _this = this;
      setTimeout(() => {
        if (_this.pageNo * 10 <= _this.array_pages) {
          _this.pageNo++;
          _this.transactions(_this.pageNo);
        } else {
          _this.allLoaded = true;
        }
        _this.$refs.loadmore.onBottomLoaded();
      }, 1500);
    },
    handleTopChange(status) {
      this.moveTranslate = 1;
      this.topStatus = status;
    },
    translateChange(translate) {
      const translateNum = +translate;
      this.translate = translateNum.toFixed(2);
      this.moveTranslate = (1 + translateNum / 70).toFixed(2);
    },
    loadTop() {
      var _this = this;
      setTimeout(() => {
        _this.transactions(1);
        _this.allLoaded = false;
        _this.pageNo = 1;
        _this.$refs.loadmore.onTopLoaded();
      }, 1500);
    },
    transactions(pageNo) {
      httpRedEnvelopeInfo({ red_envelope_id: this.id })
        .then((res) => {
          this.red_envelope_data = res.data.red_envelope_data;
          this.child_red_envelope = res.data.child_red_envelope.list;
          this.array_pages = res.data.child_red_envelope.count;
        })
        .catch(() => {});
    },
    doshare() {
      if (this.red_envelope_data.open_num <= this.red_envelope_data.total_num) {
        var p = {
          title: this.red_envelope_data.red_envelope_title,
          desp: this.red_envelope_data.red_envelope_tips,
          url: this.red_envelope_data.red_envelope_url,
        };
        console.log(p);
        share(JSON.stringify(p));
      } else {
        Toast(this.$t("红包已领完"));
      }
    },
    copy: function (event) {
      if (this.red_envelope_data.open_num <= this.red_envelope_data.total_num) {
        handleClipboard(
          this.red_envelope_data.red_envelope_url,
          event,
          () => {
            Toast(this.$t("fuzhicg"));
          },
          () => {
            Toast(this.$t("fuzhicc"));
          }
        );
      } else {
        Toast(this.$t("红包已领完"));
      }
    },
  },
};
</script>

<style scoped>
#redEnvelopeRecord {
  width: 100%;
  position: relative;
  height: 100%;
  overflow: hidden;
}
.mint-header {
  background: #fff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.join img {
  width: 20px;
  height: 20px;
}
.header_top {
  padding: 15px 15px 0 15px;
}
.top {
  width: 100%;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(5, 61, 109, 0.2);
  text-align: center;
}
.top img {
  width: 50px;
  height: 50px;
  margin: 25px 0 10px 0;
}
.top p {
  padding: 5px 0 15px 0;
}
.footer {
  width: 100%;
  height: 50px;
  background: #1296db;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  margin-top: 20px;
  border-radius: 4px;
}
.counted {
  color: #8c92a8;
  padding: 10px 0;
  border-bottom: 1px solid #e3e8ed;
}

.content {
  width: 100%;
  height: calc(100% - 320px);
  overflow: scroll;
  box-sizing: border-box;
}
.content_detail {
  padding: 0 15px 0 15px;
}
.content_detail li {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #e3e8ed;
}
.oImg {
  width: 48px;
  height: 48px;
  margin: 15px 14px 12px 14px;
}
.currency_name {
  position: relative;
  top: -30px;
}
.amount_of {
  height: 100%;
  text-align: center;
  margin-right: 10px;
}
.count {
  color: #212529;
  padding: 15px 0 10px 0;
  font-weight: bold;
}
.money {
  color: #8c92a8;
}
</style>
